var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMesh = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384",
    style: {
      enableBackground: "new 0 0 384 384"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stmesh0{fill:#161616;}\n\t.stmesh1{fill:#71A1B7;}\n\t.stmesh2{fill:none;stroke:#71A1B7;stroke-width:40;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "stmesh0",
    points: "263.4,130.8 263.4,70.5 231.9,70.5 231.9,104.2 192,70.5 73.6,170.4 94.3,170.4 94.3,301.8  289.7,301.8 289.7,170.4 310.4,170.4  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "stmesh1",
    d: "M192-0.3C86.1-0.3,0,85.8,0,191.7s86.1,192,192,192s192-86.1,192-192S297.9-0.3,192-0.3z M192,351.7 c-88.2,0-160-71.8-160-160s71.8-160,160-160s160,71.8,160,160S280.2,351.7,192,351.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "stmesh2",
    x1: 36.5,
    y1: 348,
    x2: 355,
    y2: 29.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMesh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mesh.8488e893.svg";
export { ForwardRef as ReactComponent };